/**
 * @generated SignedSource<<668e11045f69c1bc0acb91dcb840fb1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateMicrosoftTodoUserInput = {
  clientMutationId?: string | null;
};
export type MicrosoftTodoIntegrationCreateUserMutation$variables = {
  input: CreateMicrosoftTodoUserInput;
};
export type MicrosoftTodoIntegrationCreateUserMutation$data = {
  readonly createMicrosoftTodoUser: {
    readonly viewer: {
      readonly integrations: {
        readonly microsoftTodo: {
          readonly id: string;
          readonly isConnected: boolean;
          readonly unsyncedActionItemCount: number;
        } | null;
      };
    } | null;
  } | null;
};
export type MicrosoftTodoIntegrationCreateUserMutation = {
  response: MicrosoftTodoIntegrationCreateUserMutation$data;
  variables: MicrosoftTodoIntegrationCreateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MicrosoftTodoUserNode",
      "kind": "LinkedField",
      "name": "microsoftTodo",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isConnected",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unsyncedActionItemCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrosoftTodoIntegrationCreateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateMicrosoftTodoUserPayload",
        "kind": "LinkedField",
        "name": "createMicrosoftTodoUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MicrosoftTodoIntegrationCreateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateMicrosoftTodoUserPayload",
        "kind": "LinkedField",
        "name": "createMicrosoftTodoUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e853348a936bfcb607e28e53a4d90392",
    "id": null,
    "metadata": {},
    "name": "MicrosoftTodoIntegrationCreateUserMutation",
    "operationKind": "mutation",
    "text": "mutation MicrosoftTodoIntegrationCreateUserMutation(\n  $input: CreateMicrosoftTodoUserInput!\n) {\n  createMicrosoftTodoUser(input: $input) {\n    viewer {\n      integrations {\n        microsoftTodo {\n          id\n          isConnected\n          unsyncedActionItemCount\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9bda195bcd0add6246a82e098b0c848c";

export default node;
